import {PlaceholderComponent} from '../shared/placeholder.component';
import {AssignmentOverviewComponent} from './assignment-overview.component';
import {AssignmentFormComponent} from './assignment-form.component';
import {NgModule} from '@angular/core';
import {UIRouterModule} from '@uirouter/angular';
import {AssignmentCustomerFormComponent} from './assignment-customer-form.component';
import {AssignmentBuildingFormComponent} from './assignment-building-form.component';
import {AssignmentReportFormComponent} from './assignment-report-form.component';
import {ChargeFormComponent} from '../charge/charge-form.component';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'assignment',
    future: true,
    abstract: true,
    component: PlaceholderComponent,
    data: {
      pageTitle: 'states.assignment.pageTitle',
      scopes: ['assignment:read']
    }
  },
  {
    name: 'assignment.survey',
    future: true,
    component: AssignmentOverviewComponent,
    data: {
      pageTitle: 'states.assignment.survey.pageTitle',
      scopes: ['assignment:read']
    }
  },
  {
    name: 'assignment.survey.add',
    future: true,
    component: AssignmentFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.add.pageTitle',
      scopes: ['assignment:create']
    }
  },
  {
    name: 'assignment.survey.edit',
    future: true,
    component: AssignmentFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.pageTitle',
      scopes: ['assignment:update']
    }
  },
  {
    name: 'assignment.survey.edit.customer',
    future: true,
    component: AssignmentCustomerFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.customer.pageTitle',
      scopes: ['assignment-contact:create']
    }
  },
  {
    name: 'assignment.survey.edit.building',
    future: true,
    component: AssignmentBuildingFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.building.pageTitle',
      scopes: ['assignment-building:create']
    }
  },
  {
    name: 'assignment.survey.edit.report',
    future: true,
    component: AssignmentReportFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.report.pageTitle',
      scopes: ['assignment-report:create']
    }
  },
  {
    name: 'assignment.survey.edit.charge',
    future: true,
    component: ChargeFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.charge.pageTitle',
      scopes: ['charge:create']
    }
  },
  {
    name: 'assignment.survey.edit.charge.edit',
    future: true,
    component: ChargeFormComponent,
    data: {
      pageTitle: 'states.assignment.survey.edit.charge.pageTitle',
      scopes: ['charge:update']
    }
  },
  {
    name: 'assignment.execution',
    future: true,
    component: AssignmentOverviewComponent,
    data: {
      pageTitle: 'states.assignment.execution.pageTitle',
      scopes: ['assignment:read']
    }
  },
  {
    name: 'assignment.execution.add',
    future: true,
    component: AssignmentFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.add.pageTitle',
      scopes: ['assignment:create']
    }
  },
  {
    name: 'assignment.execution.edit',
    future: true,
    component: AssignmentFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.pageTitle',
      scopes: ['assignment:update']
    }
  },
  {
    name: 'assignment.execution.edit.customer',
    future: true,
    component: AssignmentCustomerFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.customer.pageTitle',
      scopes: ['assignment-contact:create']
    }
  },
  {
    name: 'assignment.execution.edit.building',
    future: true,
    component: AssignmentBuildingFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.building.pageTitle',
      scopes: ['assignment-building:create']
    }
  },
  {
    name: 'assignment.execution.edit.report',
    future: true,
    component: AssignmentReportFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.report.pageTitle',
      scopes: ['assignment-report:create']
    }
  },
  {
    name: 'assignment.execution.edit.charge',
    future: true,
    component: ChargeFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.charge.pageTitle',
      scopes: ['charge:create']
    }
  },
  {
    name: 'assignment.execution.edit.charge.edit',
    future: true,
    component: ChargeFormComponent,
    data: {
      pageTitle: 'states.assignment.execution.edit.charge.pageTitle',
      scopes: ['charge:update']
    }
  },
  {
    name: 'assignment.maintenance',
    future: true,
    component: AssignmentOverviewComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.pageTitle',
      scopes: ['assignment:read']
    }
  },
  {
    name: 'assignment.maintenance.add',
    future: true,
    component: AssignmentFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.add.pageTitle',
      scopes: ['assignment:create']
    }
  },
  {
    name: 'assignment.maintenance.edit',
    future: true,
    component: AssignmentFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.pageTitle',
      scopes: ['assignment:update']
    }
  },
  {
    name: 'assignment.maintenance.edit.customer',
    future: true,
    component: AssignmentCustomerFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.customer.pageTitle',
      scopes: ['assignment-contact:create']
    }
  },
  {
    name: 'assignment.maintenance.edit.building',
    future: true,
    component: AssignmentBuildingFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.building.pageTitle',
      scopes: ['assignment-building:create']
    }
  },
  {
    name: 'assignment.maintenance.edit.report',
    future: true,
    component: AssignmentReportFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.report.pageTitle',
      scopes: ['assignment-report:create']
    }
  },
  {
    name: 'assignment.maintenance.edit.charge',
    future: true,
    component: ChargeFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.charge.pageTitle',
      scopes: ['charge:create']
    }
  },
  {
    name: 'assignment.maintenance.edit.charge.edit',
    future: true,
    component: ChargeFormComponent,
    data: {
      pageTitle: 'states.assignment.maintenance.edit.charge.pageTitle',
      scopes: ['charge:update']
    }
  },
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    })
  ],
  exports: [UIRouterModule]
})
export class AssignmentRoutingModule {
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/assignment/assignment.routes.ts